// apps/web/src/pages/Admin/UserReports.js
import React, { useEffect, useState } from 'react';
import adminApi from '../../services/adminApi';
import styles from './Feedback.module.css'; // reuse the same table styles

export default function UserReports() {
    const [reports, setReports]   = useState([]);
    const [loading, setLoading]   = useState(true);
    const [statusFilter, setStatusFilter] = useState('');

    const load = async () => {
        setLoading(true);
        try {
            const data = await adminApi.listUserReports({ status: statusFilter || undefined });
            setReports(data ?? []);
        } catch (err) {
            console.error('Failed to load reports:', err);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => { load(); }, [statusFilter]);

    const handleStatus = async (id, status) => {
        try {
            await adminApi.updateUserReportStatus(id, status);
            setReports(prev => prev.map(r => r.id === id ? { ...r, status } : r));
        } catch (err) {
            console.error('Failed to update report:', err);
        }
    };

    return (
        <div className={styles.feedback}>
            <div className={styles.header}>
                <h1 className={styles.pageTitle}>User Reports</h1>
            </div>

            <div className={styles.filters}>
                <select
                    value={statusFilter}
                    onChange={(e) => setStatusFilter(e.target.value)}
                    className={styles.select}
                >
                    <option value="">All Statuses</option>
                    <option value="pending">Pending</option>
                    <option value="reviewed">Reviewed</option>
                </select>
            </div>

            {loading ? (
                <div className={styles.loading}>Loading reports…</div>
            ) : reports.length === 0 ? (
                <div className={styles.empty}>No reports found</div>
            ) : (
                <div className={styles.table}>
                    <table>
                        <thead>
                        <tr>
                            <th>Reporter</th>
                            <th>Reported User</th>
                            <th>Reason</th>
                            <th>Details</th>
                            <th>Status</th>
                            <th>Date</th>
                        </tr>
                        </thead>
                        <tbody>
                        {reports.map(r => (
                            <tr key={r.id}>
                                <td>@{r.reporter?.username ?? '—'}</td>
                                <td>@{r.reportedUser?.username ?? '—'}</td>
                                <td>
                                        <span className={styles.typeBadge}>
                                            {r.reason.replace(/_/g, ' ')}
                                        </span>
                                </td>
                                <td>
                                        <span title={r.details ?? ''}>
                                            {r.details ? r.details.substring(0, 60) + (r.details.length > 60 ? '…' : '') : '—'}
                                        </span>
                                </td>
                                <td>
                                    <select
                                        value={r.status}
                                        onChange={(e) => handleStatus(r.id, e.target.value)}
                                        className={styles.statusSelect}
                                    >
                                        <option value="pending">Pending</option>
                                        <option value="reviewed">Reviewed</option>
                                    </select>
                                </td>
                                <td className={styles.date}>
                                    {new Date(r.created_at).toLocaleDateString()}
                                </td>
                            </tr>
                        ))}
                        </tbody>
                    </table>
                </div>
            )}
        </div>
    );
}